const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ['year', 365 * 86400], ['month', 30 * 86400], ['week', 7 * 86400], ['day', 86400], ['hour', 3600], ['minute', 60],
];

/** "3 days ago", "yesterday", "just now". */
export function relativeTime(iso: string | null, now = Date.now()): string {
  if (!iso) return '—';
  const secs = (Date.parse(iso) - now) / 1000;
  for (const [unit, size] of UNITS) {
    if (Math.abs(secs) >= size) return rtf.format(Math.round(secs / size), unit);
  }
  return 'just now';
}

export function dateTime(iso: string): string {
  return new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' });
}

const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
export const money = (n: number | null | undefined): string => (n == null ? '—' : usd.format(n));

/** Whole days since an ISO time (0 = today). For days-in-stage. */
export const daysSince = (iso: string, now = Date.now()): number => Math.max(0, Math.floor((now - Date.parse(iso)) / 86_400_000));

/** "Mar 2026" — how cohorts (lead month) are labelled. */
export const monthLabel = (iso: string | null): string =>
  iso ? new Date(iso).toLocaleDateString('en-US', { month: 'short', year: 'numeric', timeZone: 'UTC' }) : '—';

/** First-year value: setup fee + 12 months of retainer (or the contract term, if shorter). */
export const firstYearValue = (mrr: number | null, setupFee: number | null, months: number | null): number =>
  (setupFee ?? 0) + (mrr ?? 0) * Math.min(12, months ?? 12);
